import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled, { css } from 'styled-components';
export const CommonTextInputStyles = css `
  ${transition('border-width, border-color')};
  ${fonts.lato.regular};

  --bgColour: ${brand.global.white};
  --borderColour: ${brand.grey.dark};
  --borderRadius: 4px;
  --placeholderColour: ${brand.global.black};
  --readOnlyColour: ${brand.global.black};
  --disabledColour: ${brand.grey.light};

  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
  background: var(--bgColour);
  border: 1px solid var(--borderColour);
  border-radius: var(--borderRadius);
  color: var(--textColour);
  height: 56px;
  font-size: ${fluid(14, 16)};
  margin: 0;
  padding: 7px 12px;
  width: 100%;

  [data-error='true'] & {
    border-color: ${brand.validation.invalid};
    border-width: 3px;
  }

  &:disabled,
  &[aria-disabled='true'] {
    color: var(--disabledColour);
    border-color: var(--disabledColour);
    cursor: not-allowed;
    pointer-events: none;
  }

  &:read-only,
  &[readonly] {
    color: var(--readOnlyColour);
    cursor: not-allowed;
  }

  &::placeholder {
    color: var(--placeholderColour);
    opacity: 0.5;
  }

  &:not([readonly], :read-only):focus {
    border-color: ${brand.primary.blue.dark};
    border-width: 3px;
  }
`;
const Input = styled.input `
  ${CommonTextInputStyles};
`;
const TextboxStyles = {
    Input,
};
export default TextboxStyles;
